var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner line-scale"},_vm._l((_vm.list),function(item){return _c('div',{key:item})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }